import { addToast, Button } from '@octano/global-ui';
import dayjs from 'dayjs';
import { useMemo, useState } from 'react';
import { createReportDownloadHandler } from '../../../ManagementTools/Reports/ReportSync/parts/ReportActionsCell/handlerCreator';
import { downloadFromBlob } from '../../../../utils/blob';
import { useTexts } from '../hooks/useTexts';

interface DownloadReportProps {
  teacherId: number;
  dateFilterOptions: {
    label: string;
    value: number;
    monthsDiff: number;
  }[];
  query: {
    initDate: number;
    currentPage: number;
  };
}

const downloadUrl = '/teacher-attendance';

export default function DownloadReport({
  teacherId,
  dateFilterOptions,
  query,
}: DownloadReportProps) {
  const [loading, setLoading] = useState(false);
  const texts = useTexts();

  const monthsDiff = useMemo(
    () =>
      dateFilterOptions.find((item) => item.value === query.initDate)
        ?.monthsDiff || 0,
    [dateFilterOptions, query.initDate],
  );

  const initDate = useMemo(
    () => dayjs().subtract(monthsDiff, 'month').format('YYYY/MM/DD'),
    [monthsDiff],
  );

  const handleDownload = createReportDownloadHandler({
    beforeDownload: () => setLoading(true),
    afterDownload: ({ data }) => {
      setLoading(false);
      if (data?.size === 0) {
        addToast({
          icon: 'error',
          color: 'danger',
          text: texts.report.error,
        });
      }
    },
    onSuccess: (data: Blob) => {
      if (data.size > 0) {
        const blob = new Blob([data], { type: 'vnd.ms-excel' });
        downloadFromBlob(blob, `asistencia-docente.xlsx`);
        setLoading(false);
        addToast({
          icon: 'success',
          color: 'success',
          text: texts.report.success,
        });
      }
    },
    onError: () => {
      setLoading(false);
      addToast({
        icon: 'error',
        color: 'danger',
        text: texts.report.error,
      });
    },
  });

  return (
    <Button
      icon="download"
      size="md"
      text={texts.report.btnDownload}
      loading={loading}
      fullwidth
      onClick={() =>
        handleDownload(downloadUrl, {
          teacherId,
          initDate,
        })
      }
    />
  );
}
